import { LimitedAgentProfile } from "@closerplatform/spinner-openapi";
import { observer } from "mobx-react";
import React from "react";
import { Avatar } from "@fidget/common/components/avatar/avatar";
import { useForeContext } from "../../models";
import styles from "./agentsHeaderSection.css";

interface Props {
  agent: LimitedAgentProfile;
  subtext?: string;
}

export const AgentsHeader = observer(({ agent, subtext }: Props) => {
  const {
    state: {
      shared: { orgConfig }
    }
  } = useForeContext();

  const renderAgentName = () =>
    orgConfig?.showAdviserLastNameEnabled
      ? `${agent.firstName} ${agent.lastName}`
      : agent.firstName;

  const render = () => {
    return (
      <div className={styles["agents-header"]}>
        <div className={styles["avatar-container"]}>
          <div className={styles["avatar-wrapper"]}>
            <Avatar user={agent} widgetStyle />
          </div>
        </div>
        <div className={styles["text-container"]}>
          <div className={styles.name}>{renderAgentName()}</div>
          {subtext && <div className={styles.text}>{subtext}</div>}
        </div>
      </div>
    );
  };

  return render();
});
